module.exports = __webpack_public_path__ + "static/media/Suiker.18f788a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Suiker.jpg
// module id = 326
// module chunks = 0